export default __webpack_public_path__ + "static/media/onyedinma.768dcd54.png";